// REUNIÃO GERAL (2026-09-03) — tipos da tela da pauta de sexta.
// Backend: handlers/pautaSemanal.js no comercial-engine (actions op_pauta_*),
// tabelas operacao.reunioes (tipo='geral'), reuniao_encaminhamentos,
// reuniao_anexos, reuniao_escala e reuniao_geral_config
// (migration 1792400000000_reuniao-geral.sql).

export type ReuniaoStatus = 'agendada' | 'briefing_gerado' | 'realizada' | 'consolidada';
export type CombinadoStatus = 'proposto' | 'aceito' | 'convertido' | 'descartado';

export interface PautaResumo {
  id: string;
  titulo: string;
  data_reuniao: string | null;   // YYYY-MM-DD
  semana_ref: string;            // segunda-feira da semana
  status: ReuniaoStatus;
  publicada_em: string | null;   // NULL = rascunho (só quem gerencia vê)
  publicada_por: string | null;
  apresentador_email: string | null;
  tema_tecnico: string | null;
  tem_ata: boolean;
  n_encaminhamentos: number | string;  // COUNT do PG pode vir string
  n_convertidos: number | string;
  n_anexos: number | string;
}

export interface Pauta extends PautaResumo {
  pauta_html: string | null;
  ata_html: string | null;
  participantes: string[];
  criado_por: string | null;
  criado_em: string;
  atualizado_em: string | null;
}

export interface Combinado {
  id: string;
  descricao: string;
  responsavel_email: string | null;
  contrato_id: string | null;
  contrato_numero?: string | null;
  prazo: string | null;
  status: CombinadoStatus;
  atividade_id: string | null;
  origem: 'ia' | 'manual';
  criado_em: string;
}

export interface Anexo {
  id: string;
  nome: string;
  mime: string | null;
  tamanho_bytes: number | string | null;
  criado_por: string | null;
  criado_em: string;
}

export interface EscalaItem {
  semana_ref: string;
  email: string;
  nome: string | null;           // do cadastro de profissionais, quando existe
  tema: string | null;
  confirmado_em: string | null;
}

export interface ContratoOpcao {
  id: string;
  numero: string | null;
  titulo: string | null;
}

export const STATUS_REUNIAO: Record<ReuniaoStatus, { label: string; cor: string }> = {
  agendada:        { label: 'Agendada',      cor: 'default' },
  briefing_gerado: { label: 'Pauta montada', cor: 'blue' },
  realizada:       { label: 'Realizada',     cor: 'orange' },
  consolidada:     { label: 'Fechada',       cor: 'green' },
};

export const STATUS_COMBINADO: Record<CombinadoStatus, { label: string; cor: string }> = {
  proposto:   { label: 'Proposto',      cor: 'gold' },
  aceito:     { label: 'Aceito',        cor: 'blue' },
  convertido: { label: 'virou tarefa',  cor: 'green' },
  descartado: { label: 'Descartado',    cor: 'default' },
};

// Códigos da matriz de permissões (semeados pela migration).
// .ver está em TODOS os perfis; .gerenciar em lista explícita.
export const PERM_VER = 'operacional.reuniao_geral.ver';
export const PERM_GERENCIAR = 'operacional.reuniao_geral.gerenciar';

// Configuração do robô da segunda (só admin alcança).
export interface Frente {
  nome: string;
  // Texto de GENTE. O robô nunca escreve — a pauta declara quando está vazio.
  porque: string;
}

export interface PautaConfig {
  ativo: boolean;
  destinatarios_aviso: string[];
  dia_semana: number;      // 1 = segunda … 7 = domingo (ISO)
  hora: string;            // 'HH:MM'
  fontes_noticias: unknown[];
  frentes: Frente[];
}
